import React from "react";

import { statusMap } from "./lib/constants";

const CountItem = ({ stateKey, value }) => {
    return (
        <div className="count">
            <h3>{value}</h3>
            {statusMap[stateKey] && statusMap[stateKey].label ? statusMap[stateKey].label : ""}
        </div>
    );
};

export default CountItem;
